module.exports = __webpack_public_path__ + "static/media/money.c160e578.svg";